import './style.css'
import ReactDOM from 'react-dom/client'
import { Canvas } from '@react-three/fiber'
import { Perf } from 'r3f-perf'
import { Sky, OrbitControls } from '@react-three/drei'

import Lights from './lights.js'
import Village from './decor.js'
import Nuages from './nuages.js'
import Maisons from './maisons.js'


const root = ReactDOM.createRoot(document.querySelector('#root'))

root.render(

    <Canvas 
        shadows
        camera={ {
            fov: 45,
            near: 0.5,
            far: 150,
            position : [6,2.5,6]
        } }>
        
        {/* <Perf position="top-left" /> */}


        <OrbitControls 
            makeDefault 
            maxPolarAngle={ Math.PI / 2.1}
            minPolarAngle = {0}
            minDistance = {5}
            maxDistance = {20}
            autoRotate = {true}        
            autoRotateSpeed = {-0.3}
            screenSpacePanning = {false}
        />

        
        <Lights />

        <Sky sunPosition={[17, 20, -17]}></Sky>
        
        <Village></Village>
        
        <Nuages ></Nuages> 

        <Maisons></Maisons>


    </Canvas>
)
